import moment from 'moment';
import { isToggleActive } from '../../../components/featureToggle/toggles';
import { CURRENT_USER, SAVE_HASHI_NOTE } from '../../../graphql';

export const LiveOnly = [
  {
    id: 'welcome',
    type: 'letstalk',
    hideCountText: true,
  },
  {
    id: 'previouslyDiagnosed',
    type: 'single',
    endpoint: 'medicalHistory',
    onlyFirstTime: true,
    sendToAthena: true,
    prompt: 'When were you diagnosed with hypothyroidism?',
    isHPI: true,
    hpiIndex: 0,
    savingSection: 'diagnosed',
    isSaveTemp: true,
    options: [
      {
        questionId: '19',
        value: 'Select a year',
        answer: 'Y',
        giveDetails: true,
        inputType: 'number',
        min: 1900,
        max: parseInt(moment().format('YYYY'), 10),
        step: 1,
        goToPage: 'cancerhistory',
      },
      {
        questionId: '19',
        value: 'I never got diagnosed',
        answer: 'N',
      },
    ],
    onSubmitHandler: (selectedOptions, _, session) => {
      // console.log({ selectedOptions });
      if (selectedOptions.answer === 'N') {
        if (session && !!isToggleActive('ALLOW_HASHI_ONLY_BOOK') && !!session.diagnoseFull.hasHashi && !!session.diagnoseFull.hashiNotes) return '/schedule';
      }

      return null;
    },
    hpiComputer: (selectedValues, session) => {
      let age = moment().diff(session.dob, 'years');
      const initialString = `${session.firstName} is a ${age} years old ${session.gender.toLowerCase() === 'f' ? 'woman' : 'man'}`;
      if (!selectedValues || selectedValues.answer.toLowerCase === 'no') {
        return initialString + ' who never got diagnosed. ';
      }
      let year = `on ${selectedValues.value}`;
      try {
        year = `in ${selectedValues.value.substring(0, 4)}`;
      } catch {}

      return `${initialString}, diagnosed with hypothyroidism ${year}. `;
    },
    preCheckDisplay: (session, history) => {
      if (
        session &&
        !!session.diagnoseFull &&
        ((!!session.diagnoseFull.hasHypo && !!session.diagnoseFull.hypoNotes) || (!!isToggleActive('ALLOW_HASHI_ONLY_BOOK') && !!session.diagnoseFull.hasHashi && !!session.diagnoseFull.hashiNotes))
      ) {
        history.push('/schedule');
      }
      if (session && !!session.diagnoseFull && (!!session.diagnoseFull.hasHypo && !!session.diagnoseFull.hypoNotes)) {
        return false;
      }
      return true;
    },
  },
  {
    id: 'hashimoto',
    type: 'single',
    endpoint: 'medicalHistory',
    onlyFirstTime: true,
    sendToAthena: true,
    prompt: `Have you been diagnosed with Hashimoto's?`,
    isHPI: true,
    hpiIndex: 1,
    savingSection: 'diagnosed',
    isSaveTemp: true,
    options: [
      {
        questionId: '281',
        value: 'Select a year',
        answer: 'Y',
        giveDetails: true,
        inputType: 'number',
        min: 1900,
        max: parseInt(moment().format('YYYY'), 10),
        step: 1,
      },
      {
        questionId: '281',
        value: 'No',
        answer: 'N',
      },
    ],
    onSubmitHandler: (selectedOptions, getState, session, client) => {
      const st = getState();
      // console.log({ selectedOptions, st, session });
      if (selectedOptions.answer === 'N') {
        if (session && !!isToggleActive('ALLOW_HASHI_ONLY_BOOK') && !!session.diagnoseFull.hasHashi && !!session.diagnoseFull.hashiNotes) return '/schedule';
      }
      if (selectedOptions.answer !== 'N') {
        if (!!isToggleActive('ALLOW_HASHI_ONLY_BOOK')) {
          let hypoAnswered = false;
          if (st && st.values && st.values.length > 0) {
            const hypo = st.values.find((x) => x.id === 'previouslyDiagnosed');
            if (!!hypo && hypo.values && hypo.values.answer) {
              hypoAnswered = true;
            }
          }
          if (client && session) {
            client.mutate({
              mutation: SAVE_HASHI_NOTE,
              variables: {
                answer: 'Y',
                year: (selectedOptions.value || '').toString(),
                hypoAnswer: hypoAnswered ? 'N' : null,
              },
              refetchQueries: [{ query: CURRENT_USER }],
              awaitRefetchQueries: true,
            });
          }
          return '/schedule';
        }
        // return '/schedule';
      }

      return null;
    },
    // onSubmitHandler: selectedOptions => {
    //   console.log({selectedOptions})
    //   if (selectedOptions.answer!=='N') {
    //     return '/schedule';
    //   }

    //   return null;
    // },
    hpiComputer: (selectedValues, session) => {
      let age = moment().diff(session.dob, 'years');
      const initialString = `${session.firstName} is a ${age} years old ${session.gender.toLowerCase() === 'f' ? 'woman' : 'man'}`;
      if (!selectedValues || selectedValues.answer.toLowerCase === 'no') {
        return initialString + ' who never got diagnosed. ';
      }
      let year = `on ${selectedValues.value}`;
      try {
        year = `in ${selectedValues.value.substring(0, 4)}`;
      } catch {}

      return `${initialString}, diagnosed with hashimoto's ${year}. `;
    },
    preCheckDisplay: (session, history) => {
      if (
        session &&
        !!session.diagnoseFull &&
        ((!!session.diagnoseFull.hasHypo && !!session.diagnoseFull.hypoNotes) || (!!isToggleActive('ALLOW_HASHI_ONLY_BOOK') && !!session.diagnoseFull.hasHashi && !!session.diagnoseFull.hashiNotes))
      ) {
        history.push('/schedule');
      }
      if (session && !!session.diagnoseFull && (!!session.diagnoseFull.hasHashi && !!session.diagnoseFull.hashiNotes)) {
        return false;
      }
      return true;
    },
  },
  {
    id: 'cancerhistory',
    type: 'single',
    endpoint: 'medicalHistory',
    onlyFirstTime: true,
    sendToAthena: true,
    savingSection: 'cancerHistory',
    prompt: 'Do you or did you ever have a history of thyroid cancer?',
    options: [
      {
        questionId: window._env_.REACT_APP_GRAPHQL_URL.indexOf('preview') > -1 || window._env_.REACT_APP_GRAPHQL_URL.indexOf('localhost') > -1 ? '297' : '301',
        value: 'No',
        answer: 'N',
        goTo: '/schedule',
      },
      {
        questionId: window._env_.REACT_APP_GRAPHQL_URL.indexOf('preview') > -1 || window._env_.REACT_APP_GRAPHQL_URL.indexOf('localhost') > -1 ? '297' : '301',
        value: 'Yes',
        answer: 'Y',
        goToPage: 'disqualifiedcancer',
        placeholder: 'Tell us more',
        giveDetails: true,
        giveDetailsEnforce: true,
      },
    ],
    onSubmitHandler: (selectedOptions) => {
      // console.log({ selectedOptions });
      // if (selectedOptions.answer!=='N') {
      //   return '/schedule';
      // }

      return null;
    },
  },
  {
    id: 'testFirst',
    hideCountText: true,
    type: 'testFirst',
  },
  {
    id: 'disqualifiedcancer',
    type: 'disqualified',
    hideCountText: true,
    endpoint: 'disqualified',
    onlyFirstTime: false,
    prompt: 'disqualified',
    variant: 'cancer',
  },
];
